export default __webpack_public_path__ + "static/media/calendar.daad7fbe.png";